import React, { useEffect, useState } from "react";
import HeroSwiper from "../../Components/UserComponents/HeroSwiper";
import SearchInput from "../../Components/UserComponents/searchInputs";
import GuestProfile from "../../Components/common/guestProfile";
import CardWrapper from "../../Components/common/cardWrapper";
import UserExploreCard from "../../Components/UserComponents/userExploreCard";
import BookingActionCard from "../../Components/common/bookingActionCard";
import Button from "../../Components/common/Button";
import TrendingProperty from "../../Components/UserComponents/TrendingProperty";
import DatePicker from "../../Components/UserComponents/datePicker";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiMainUser, apiPublicUser } from "../../utils/constant";
import UserBottomBar from "../../Module/User/UserBottomBar";
import ButtonPopup from "../../Components/common/ButtonPopup";
import { faAngleDown, faHouse, faHeadset, faSpa, faShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WrapperPopup from "../../Components/common/wrapperPopup";
import MobHeadDestinationGuest from "../../Module/User/MobHeadDestinaionGuest";
import MobHeadNav from "../../Module/User/MobHeadNav";
import { Swiper, SwiperSlide } from "swiper/react";
import SkeletonLoader from "../../Components/common/SkeletonLoader";
import SkeletonTrendingProperty from "../../MobSkeleton/SkeletonTrendingProperty";
import VerifactionToNavigateHost from "../../Components/common/VerifactionToNavigateHost";
import { useSelector } from "react-redux";

const Home = () => {
  const [successdata, setSuccessData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 500);

  const [sortingOption, setSortingOption] = useState("");

  const [openModalNav, setOpenModalNav] = useState(false);

  const navigate = useNavigate()


   //sorting filter------------------------------------
   const [activeSortingOption, setActiveSortingOption] = useState(null);

   const [selectedFilterText, setSelectedFilterText] = useState("Type");
 
  const handleSortingOptionClick = (option) => {
 
    if (activeSortingOption === option) {
      setActiveSortingOption(null);
      setSortingOption("");
      // setSelectedFilterText('Type')
    } else {
      setActiveSortingOption(option);
      setSortingOption(option);
      // Call the API only in desktop view
      if (window.innerWidth > 500) {
        fetchDatapProperty();
      }
      // setSelectedFilterText(option);
    }
    
  };

   
 
   const isOptionActive = (option) => {
     return sortingOption === option ? "active-sort" : "";
   };
 


  const fetchDatapProperty = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiPublicUser + "search_property", {
        params: {
          sortby: sortingOption,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const list = response?.data?.data || [];
      if (response.status === 200 && Array.isArray(list) && list.length > 0) {
        setSuccessData(list);
      } else {
        setSuccessData("No Property Found");
      }
    } catch (error) {
      setSuccessData("No Property Found");
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchDatapProperty();
  }, [])

  useEffect(() => {
    const onResize = () => setIsSmallScreen(window.innerWidth <= 500);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth > 500) {
      fetchDatapProperty();
    }
  }, [sortingOption]);


  const fetchDataOnSave = () => {
    let filterText = "";
    switch (sortingOption) {
      case "booking":
        filterText = "Most Booked";
        break;
      case "low2high":
        filterText = "Price : Low to High";
        break;
      case "high2low":
        filterText = "Price : High to Low";
        break;
      default:
        filterText = "Type";
        break;
    }
    setSelectedFilterText(filterText);
    fetchDatapProperty();
  };

  const handleClearFilters = () => {
    setActiveSortingOption(null);
    setSortingOption("");
    setSelectedFilterText("Type");
    if (window.innerWidth > 500) {
      fetchDatapProperty();
    }
  };



  const toggleVisibleDocks = () => {
    setOpenModalNav((prevVisible) => !prevVisible);
  };


  const [isVisible, setIsVisible] = useState('');
  const storeSel = useSelector((state) => state);

  const userName = storeSel.hostDetailSlice.user_Name;

  const [verficationData,setVerificationData] = useState()

  const [verificatioProfilePop,setVerificationProfilePop] = useState(false)


  const toggleVisibleDocksHostNav = () => {
    setVerificationProfilePop(false)
    }


const handleUniqueID = (uniqueID) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(entry.target.id === uniqueID ? uniqueID : '');
        }
      });
    },
    { threshold: 0.4 }
  );

  const targetElement = document.getElementById(uniqueID);
  if (targetElement) {
    observer.observe(targetElement);
  }

  return () => {
    if (targetElement) observer.unobserve(targetElement);
    observer.disconnect();
  };
};

  // Updating here the URL based on sorting option
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (sortingOption) {
    params.set("sort", sortingOption);
  } else {
    params.delete("sort");
  }
  const newUrl = params.toString() ? `${window.location.pathname}?${params}` : window.location.pathname;
  window.history.replaceState({}, "", newUrl);
  }, [sortingOption]);


  useEffect(() => {
    const fetchData = async () => {
      try {
 
        const userResponse = await axios.get(apiMainUser + "get_user_detail", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }
        });
        console.log(userResponse.data.data,'checkResponseNew')
        setVerificationData(userResponse.data.data[0])
      } catch (error) {
      }
    };

    fetchData();
  }, [userName]); // Trigger the effect whenever userName changes
  const handleSwitchToHosting = () => {
    if (verficationData?.mobile_verified !== 0 && verficationData?.email_verified !== 0 && verficationData?.user_docs_details !== []) {
      navigate("/host");
    } else {
      setVerificationProfilePop(true);
    }
  };

    
    
  
  // Reusable benefit card helper
  const BenefitCard = ({ icon, title, sub }) => (
    <CardWrapper wrapperClass="home-key-benefits-card">
      <div className="benefit-tile">
        <FontAwesomeIcon icon={icon} className="benefit-icon" aria-hidden="true" />
        <div className="benefit-copy">
          <h4 className="benefit-title">{title}</h4>
          <p className="benefit-sub">{sub}</p>
        </div>
      </div>
    </CardWrapper>
  );
  
  return (
    <>
      <h1 className="visually-hidden">Jumbo Holidayz – Private Luxury Stays</h1>
   
    <div className="user-home-page">
    {isSmallScreen && <MobHeadNav
      onClickSearch={() => setOpenModalNav(true)}
      position=""
    />}

      <div className="hero-section">
        <HeroSwiper />
      </div>

      <div className="main-section">
        {/*  */}
        {!isSmallScreen ? (
          <div className="key-benefits-div">
            <BenefitCard icon={faHouse} title="100% Private Stays" sub="Entire villa or apartment. No shared spaces. Total privacy." />
            <BenefitCard icon={faHeadset} title="Verified Hosts & 24×7 Support" sub="On-ground assistance and quick resolution whenever you need it." />
            <BenefitCard icon={faSpa} title="Curated Luxury Amenities" sub="Pools, jacuzzis, chef‑on‑call — handpicked for memorable stays." />
            <BenefitCard icon={faShield} title="Quality‑Checked Homes" sub="Verified listings with consistent standards for a worry‑free stay." />
          </div>
        ) : (
          <div className="key-benefits-swiper">
            <Swiper
              spaceBetween={12}
              slidesPerView={1.1}
              centeredSlides={true}
              centerInsufficientSlides={true}
              centeredSlidesBounds={true}
              autoPlay={{ delay: 2500 }} 
              loop={true}
            >
              <SwiperSlide>
                <BenefitCard icon={faHouse} title="100% Private Stays" sub="Entire villa or apartment. No shared spaces. Total privacy." />
              </SwiperSlide>
              <SwiperSlide>
                <BenefitCard icon={faHeadset} title="Verified Hosts & 24×7 Support" sub="On-ground assistance and quick resolution whenever you need it." />
              </SwiperSlide>
              <SwiperSlide>
                <BenefitCard icon={faSpa} title="Curated Luxury Amenities" sub="Pools, jacuzzis, chef‑on‑call — handpicked for memorable stays." />
              </SwiperSlide>
              <SwiperSlide>
                <BenefitCard icon={faShield} title="Quality‑Checked Homes" sub="Verified listings with consistent standards for a worry‑free stay." />
              </SwiperSlide>
            </Swiper>
          </div>
        )}
        {/*  */}

        {/*    */}
        {/* <div className="home-explore-jumbo-div">
          <h3 className="jumbo-topic-heading">Explore Jumbo</h3>
          <p className="explore-sub-para">
            Escape the ordinary and discover a world of luxury in our portfolio
            of vacation rentals.
          </p>
          <div className="explore-jumbo-card-box">
            <UserExploreCard
              src="./assets/img/exploreStateImg.jpg"
              exploreCarText="Gorakhpur"
            />
            <UserExploreCard
              src="./assets/img/exploreStateImg.jpg"
              exploreCarText="Delhi"
            />
            <UserExploreCard
              src="./assets/img/exploreStateImg.jpg"
              exploreCarText="Assam"
            />
            <UserExploreCard
              src="./assets/img/exploreStateImg.jpg"
              exploreCarText="Sikkim"
            />
            <UserExploreCard
              src="./assets/img/exploreStateImg.jpg"
              exploreCarText="Mumbai"
            />
            <UserExploreCard
              src="./assets/img/exploreStateImg.jpg"
              exploreCarText="Goa"
            />
          </div>
        </div> */}

       

        {/*  */}
        <div className="home-trending-property-div">
          <style>{`
            .benefit-tile{display:flex;gap:12px;align-items:flex-start}
            .benefit-icon{font-size:22px;min-width:22px}
            .benefit-title{margin:0 0 4px 0;font-size:16px;line-height:1.2}
            .benefit-sub{margin:0;color:#666;font-size:14px;line-height:1.35}
            .skeleton-wrap{width:100%}
          `}</style>
          {/* ARIA live region for screen readers */}
          <div className="visually-hidden" aria-live="polite">
            {selectedFilterText}
          </div>
          <h3 className="jumbo-topic-heading">Trending Properties</h3>
          <p className="explore-sub-para">
            Discover highly rated stays and guest favorites across Jumbo Holidayz.
          </p>
          <div className="home-trending-flex-box">
             
              {/* <Button btnclasses="tab-btn-hover" btnText="Our top Picks" />
              <Button btnclasses="tab-btn-hover" btnText="Most popular" />
              <Button btnclasses="tab-btn-hover" btnText="Most Booked" />
              <Button btnclasses="tab-btn-hover" btnText="Family Friendly" />
              <Button btnclasses="btn-filter" btnText="More Filter" /> */}
              {!isSmallScreen ? (
                <CardWrapper wrapperClass={`trending-property-sort-card sticky-t-111`}>
                  <div className="filter-toolbar" role="toolbar" aria-label="Sort options">
                    <div className="filter-toolbar__chips">
                      <button
                        type="button"
                        onClick={() => handleSortingOptionClick("booking")}
                        className={`tab-btn-hover chip-btn ${isOptionActive("booking")}`}
                        aria-pressed={sortingOption === "booking"}
                        title="Sort by most booked"
                      >
                        Most Booked
                      </button>
                      <button
                        type="button"
                        onClick={() => handleSortingOptionClick("low2high")}
                        className={`tab-btn-hover chip-btn ${isOptionActive("low2high")}`}
                        aria-pressed={sortingOption === "low2high"}
                        title="Sort by price low to high"
                      >
                        Price: Low → High
                      </button>
                      <button
                        type="button"
                        onClick={() => handleSortingOptionClick("high2low")}
                        className={`tab-btn-hover chip-btn ${isOptionActive("high2low")}`}
                        aria-pressed={sortingOption === "high2low"}
                        title="Sort by price high to low"
                      >
                        Price: High → Low
                      </button>
                    </div>
                    <div className="filter-toolbar__selected-mini" aria-live="polite">
                      {selectedFilterText !== 'Type' ? selectedFilterText : ''}
                    </div>
                  </div>
                </CardWrapper>
              ) : null}

            
            {isSmallScreen ?
        <ButtonPopup
           wrapclass={`absolute  custom-mob-filter-card`}
           buttonPopup={true}
          showCloseButton={true}
          closeBtnText="Cancel"
          showApplyButton={true}
          applyBtnText="Save"
          onApply={fetchDataOnSave}
        divContent={
          <>
        <Button
            onClick={() => handleSortingOptionClick("booking")}
            btnclasses={`tab-btn-hover  w-100 ${isOptionActive("booking")}`}
            btnText="Most Booked" />
            <Button
            onClick={() => handleSortingOptionClick("low2high")}
            btnclasses={`tab-btn-hover  w-100 ${isOptionActive("low2high")}`}
           btnText="Price : Low to High" />
            <Button
            onClick={() => handleSortingOptionClick("high2low")}
            btnclasses={`tab-btn-hover  w-100 ${isOptionActive("high2low")}`}
            btnText="Price : High to Low" />
          </>
        }
        makeCustom={
          <button
            className={`custom-filter-btn`}
            aria-haspopup="dialog"
            aria-expanded={openModalNav ? "true" : "false"}
            title="Open property sort menu"
          >
            {selectedFilterText}
            <FontAwesomeIcon icon={faAngleDown} className="arrow-icon-filter" />
          </button>
        }
      />
      : null}

  <div className="all-trending-property-box">
    {loading ? (
      <div className="skeleton-wrap">
        {[...Array(5)].map((_, i) => (
          <SkeletonTrendingProperty key={i} />
        ))}
      </div>
    ) : successdata === "No Property Found" ? (
      <CardWrapper wrapperClass="empty-state-card text-center">
        <img src="./assets/img/notFoundImage.png" alt="No properties found" loading="lazy" />
        <p className="mt-2">No properties match your filters yet.</p>
      </CardWrapper>
    ) : (
      successdata.slice(0, 5).map((data, index) => {
        const amenitiesToDisplay = Array.isArray(data?.amenities_details)
          ? data.amenities_details.slice(0, 3)
          : [];
        return (
          <TrendingProperty
            key={data?.propertyid ?? index}
            index={index}
            isVisible={isVisible}
            handleUniqueID={handleUniqueID}
            property_name={data.property_name}
            img={
              data.images && data.images.length > 0
                ? data.base_url_image + data.images[0]
                : "./assets/img/notFoundImage.png"
            }
            swiperSlides={
              data.images && data.images.length > 0
                ? data.images.map((imgUrl, i) => ({
                    imgUrl: data.base_url_image + imgUrl,
                    altText: `Slide ${i + 1}`,
                  }))
                : [
                    {
                      imgUrl: "./assets/img/notFoundImage.png",
                      altText: "Not Found Image",
                    },
                  ]
            }
            priceValue={data.base_price}
            location={data.city + ", " + data.state}
            maxguest={data.max_guests}
            rooms={data.bedrooms}
            beds={data.beds}
            bath={data.bathrooms}
            amenities={amenitiesToDisplay}
            slug={"/properties/" + data.city + "/" + data.slug}
            amenitiesCount={Math.max(0, (Array.isArray(data?.amenities_details) ? data.amenities_details.length : 0) - 3)}
            reviewNum={data?.review_count}
            starNum={data?.Overall_rating}
            WishListpropID={data.propertyid}
            wishListApplied={data.wishlist}
          />
        );
      })
    )}
    <div className="text-center mt-10">
      <Link
        className="underline pointer font-small"
        to={sortingOption ? `/properties?sort=${sortingOption}` : "/properties"}
        aria-label="View all properties"
      >
        View All
      </Link>
    </div>
    </div>



          </div>
        </div>

   


        <div className="home-experience-more-img-box">
          <a href="https://link.jumboholidayz.com/getapp/" target="_blank" rel="noopener noreferrer">
            <img src="./assets/img/homePartnerImg.png" alt="Get the Jumbo Holidayz app" loading="lazy" />
          </a>
        </div>

        <div className="home-experience-more-img-box" 
            onClick={handleSwitchToHosting}
            >
          <img src="./assets/img/homeExpImg.png" alt="Switch to hosting" loading="lazy" />
        </div>
      </div>


      
    </div>




    <div className='Mob-destination-guest-popup-div'>
          {openModalNav && (
        <WrapperPopup
        fluid={true}
        DockFilter={true}
        headingText='Select Date and Guest'
        position='bottom'
        // dimMode={props.opaque ? props.opaque : false}
        defaultSize={"0.90"}
        dimStyle={false}
        // isVisible={openModalNav}
        isVisible={true}
        
        setVisibleDocks={toggleVisibleDocks} 
        closeModal={setOpenModalNav}
         comp={
         <MobHeadDestinationGuest
          closeModal={setOpenModalNav}/>
        }
         />
      )}
      </div>
      <div className="edit-booking-preference-popup">
        {verificatioProfilePop && (
          <WrapperPopup
          fluid={true}
          defaultSize={"0.90"}
          dimStyle={false}
          isVisible={true} 
          setVisibleDocks={toggleVisibleDocksHostNav} 
          closeModal={setVerificationProfilePop}
          comp={
         <VerifactionToNavigateHost
         closeModal={setVerificationProfilePop}
         />
        }
        />
        )}
      </div>
    </>
  );
};

export default Home;

